Ext.define('PanelWizardFilterTypyTaborow', {
    extend: 'Ext.panel.Panel',
    initComponent: function () {
        this.cid = Ext.id();
        Ext.apply(this, {
            layout: "fit",
            frame: false,
            border: false,
            autoWidth: false,
            autoHeight: false,
            items: [{
                xtype: 'form',
                frame: false,
                border: false,
                autoWidth: true,
                autoHeight: true,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0"
                },
                id: this.cid + "formpanel",
                labelWidth: 100,
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1.0,
                        layout: 'form',
                        labelWidth: 100,
                        defaults: {
                            anchor: "0"
                        },
                        frame: false,
                        border: false,
                        items: [{
                            id: this.cid + "KOMUNIKACYJNY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_taborow[0].capitalise()
                        }, {
                            id: this.cid + "NIEKOMUNIKACYJNY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_taborow[1].capitalise()
                        }, {
                            id: this.cid + "ZAKLADOWY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_taborow[2].capitalise()
                        }]
                    }]
                }]
            }]
        });
        this.callParent(arguments);
    },
    callAfterShow: function () {
        var t0 = Ext.getCmp(this.cid + "KOMUNIKACYJNY");
        var t1 = Ext.getCmp(this.cid + "NIEKOMUNIKACYJNY");
        var t2 = Ext.getCmp(this.cid + "ZAKLADOWY");
        var bbem = this.datad.mainCtrl.repDef.typyTaborow.length == 0;
        t0.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyTaborow, Const.TYP_TABORU_KOMUNIKACYJNY) || bbem);
        t1.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyTaborow, Const.TYP_TABORU_NIEKOMUNIKACYJNY) || bbem);
        t2.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyTaborow, Const.TYP_TABORU_ZAKLADOWY) || bbem);

        this.callAfterShowCalled = true;
    },
    callAfterHide: function () {
        if (this.callAfterShowCalled) {
            var t0 = Ext.getCmp(this.cid + "KOMUNIKACYJNY");
            var t1 = Ext.getCmp(this.cid + "NIEKOMUNIKACYJNY");
            var t2 = Ext.getCmp(this.cid + "ZAKLADOWY");
            this.datad.mainCtrl.repDef.typyTaborow = [];
            if (t0.getValue())
                this.datad.mainCtrl.repDef.typyTaborow.push(Const.TYP_TABORU_KOMUNIKACYJNY);
            if (t1.getValue())
                this.datad.mainCtrl.repDef.typyTaborow.push(Const.TYP_TABORU_NIEKOMUNIKACYJNY);
            if (t2.getValue())
                this.datad.mainCtrl.repDef.typyTaborow.push(Const.TYP_TABORU_ZAKLADOWY);
        }
        return null;
    },
    setData: function (datad) {
        this.datad = datad;
    }
});
